import React from 'react'
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from 'react-router-dom';

const Card = ({item}) => {
  const Navigate = useNavigate();

  console.log("pre order",item)
  return (
  <div className='w-full  '>
    <div className='  bg-white rounded-tr-[560px] pl-5 rounded-tl-5xl w-[90%]'>
        <div className='w-2/3 pt-16 pl-0'>
      <img src={item?.image?.location} className='w-[80%] ' alt=''/>
      </div>
    </div>
    <div className='bg-white px-5 py-4 w-[90%] rounded-b-3xl shadow-2xl shadow-Background2'>
        <div className='w-full h-14'>
          <span className='text-xl  text-textColor w-3/4 '>
          {item?.name}
          </span>
          </div>
        <div className='flex justify-end px-1'>
            <div className='bg-textColor px-3 py-1 rounded-3xl text-lg font-semibold text-white flex gap-1 items-center justify-center mt-3 cursor-pointer hover:bg-Background6' onClick={()=>{
              Navigate(`/product/${item?._id}/${item?.type}`)
            }}>
              <span className='text-sm flex'>Explore </span><span className='flex'><IoIosArrowForward className='mt-0.5 text-[15px]' /></span></div>
        </div>
    </div>
    </div>
  )
}

export default Card
